import { BitfMatOkCancelDialogComponent } from 'common/libs/bitforce/core/components/ui/bitf-mat-ok-cancel-dialog/bitf-mat-ok-cancel-dialog.component';
import { ContextBase } from '../../app/armp/models/response/AtpConfig';

export const CONSTANTS = {
  COLORS: {
    red: '#f44336',
    darkRed: '#b71c1c',
    green: '#4caf50',
    orange: '#ff9800',
    grey: '#9e9e9e',
    lightGrey: '#fafafa',
    lightBlue: '#80D8FF'
  },
  okCancelDialogComponent: BitfMatOkCancelDialogComponent
};

export const contextBaseExample: ContextBase = {
  configType: 'MAIN',
  subConfig: {
    domains: {
      configType: 'DOMAIN_LIST',
      subConfig: undefined
    }
  }
};

export const ArubaTrustedPlatformName = 'ArubaTrustedPlatform';
